import { useState } from "react";
import { CreateCampaignDialog } from "src/pages/lifecycle-studio/emails/components/create-campaign-dialog";

export type CreateCampaignTarget = {
  contentEmailId: string;
  contentEmailVersionId: string;
};

/** Holds the campaign dialog for `CreateCampaignMenuItem`; render `dialog` outside the menu's toolbar. */
export function useCreateCampaign() {
  const [target, setTarget] = useState<CreateCampaignTarget>();
  const dialog = target ? (
    <CreateCampaignDialog
      isOpen
      onClose={() => setTarget(undefined)}
      contentEmailId={target.contentEmailId}
      contentEmailVersionId={target.contentEmailVersionId}
    />
  ) : null;
  return { requestCreate: setTarget, dialog };
}
